import styled, { createGlobalStyle } from 'styled-components';

// Keyframes copied verbatim from the HTML prototypes so the tick/halo/pulse/skeleton
// animations match the design. Injected once (mounted by the widget / dropdown).
export const AdLicenseAnimations = createGlobalStyle`
  @keyframes adlTickRing { 0% { transform: scale(.8); opacity: 0; } 35% { transform: scale(1); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
  @keyframes adlTickHalo { 0% { transform: scale(.85); opacity: .5; } 70% { transform: scale(1.45); opacity: 0; } 100% { transform: scale(1.45); opacity: 0; } }
  @keyframes adlTickDraw { 0% { stroke-dashoffset: 24; } 55% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: 0; } }
  @keyframes adlSkelShine { 0% { background-position: -320px 0; } 100% { background-position: 320px 0; } }
`;

// Mobile bottom-sheet chrome: DrawerModal forces a blank title so the drag handle (rendered on
// .ant-drawer-header) stays, but that empty header + default body padding adds a big gap above our
// own content header. Collapse the header to just the drag handle and drop the body padding, scoped
// to the ad-license sheets (they also render their own headers/padding). Mounted by the list modal.
export const AdLicenseSheetStyles = createGlobalStyle`
  .ad-license-sheet.drawer-container .ant-drawer-header {
    padding: 0;
    min-height: 20px;
    border-bottom: 0;
  }
  .ad-license-sheet.drawer-container .ant-drawer-header-title {
    display: none;
  }
  .ad-license-sheet.drawer-container .ant-drawer-body {
    padding: 0;
  }
  /* The pagination jump "…" renders on the text baseline, sitting lower than the page
     numbers. AntD positions it with a 3-class selector, so match that depth to win on
     specificity: stretch it over the full item box and flex-center the dots. */
  .ad-license-list-modal .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
  .ad-license-list-modal .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
    position: absolute;
    inset: 0;
    height: auto;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
`;

// Footer bar for the REGA detail view (license text on the start, Post Now at the end).
export const DetailFooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: ${({ $isMobile }) => ($isMobile ? '14px 16px' : '14px 24px')};
  border-block-start: 1px solid #f0f0f0;
`;

export const FooterLicenseText = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgb(112, 112, 112);
  font-size: 13px;
`;

// Skeleton shimmer block used for card/list loading states (HTML skelShine).
export const SkeletonBlock = styled.span`
  display: block;
  border-radius: ${({ radius = '6px' }) => radius};
  height: ${({ height = '16px' }) => height};
  width: ${({ width = '100%' }) => width};
  background: linear-gradient(90deg, #f2f3f5 25%, #e9ebee 37%, #f2f3f5 63%);
  background-size: 640px 100%;
  animation: adlSkelShine 1.2s ease-in-out infinite;
`;

// Reusable card shell matching the dashboard widget / backlog shells.
export const CardShell = styled.div`
  display: grid;
  gap: ${({ gap = '14px' }) => gap};
  padding: ${({ padding = '16px 20px' }) => padding};
  background: #fff;
  border: 1px solid ${({ borderColor = '#f0f0f0' }) => borderColor};
  border-radius: ${({ radius = '10px' }) => radius};
`;

// Green primary CTA used across widget / cards (theme secondary-color = #006169).
export const GreenButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 0 0 auto;
  height: ${({ height = '36px' }) => height};
  padding: 0 ${({ paddingX = '18px' }) => paddingX};
  border-radius: 6px;
  font-family: inherit;
  font-size: ${({ fontSize = '14px' }) => fontSize};
  font-weight: 600;
  line-height: 1.5715;
  white-space: nowrap;
  cursor: pointer;
  background: ${({ theme }) => theme['secondary-color'] || '#006169'};
  color: #fff;
  border: 1px solid ${({ theme }) => theme['secondary-color'] || '#006169'};
  transition: background 0.2s ease, border-color 0.2s ease;
  &:hover {
    background: #1e9c5f;
    border-color: #1e9c5f;
  }
`;
